import React, { Component } from 'react'
import { connect } from 'react-redux';
import selecionarItemFechamento from '../../actions/fechamento-caixa/selecionarItemFechamento';
import { withRouter } from 'react-router-dom';

class AcoesFechamentoCaixa extends Component {
  vizualizarFechamento () {
    const modal = this.props.history.location.pathname === '/painel-fechamento-caixa-agencia' ? '#modalFechamentoCaixaAgencia' : '#modalFechamentoCaixa';
    return (
      <a className="vx-gp-dropdown-item" data-toggle="modal" data-target={modal}
         onClick={() => { this.props.selecionarItemFechamento(this.props.item) }}>
        <i className="material-icons">visibility</i>
        Visualizar Fechamento
      </a>
    )
  }

  exibirDetalhamento () {
    let url = `/${this.props.paginaDetalhamento}`;
    if (this.props.seAgencia) {
      url = url + `?fechamento=${this.props.item.id}`;
    } else {
      url = url + `?usuarioEmpresa=${this.props.item.idUsuarioEmpresa}&data=${this.props.item.dataFechamentoSemFormatacao}`;
      if (this.props.item.id) {
        url = url + `&fechamento=${this.props.item.id}`;
      }
    }
    return (
      <a className="vx-gp-dropdown-item"
         onClick={() => { this.props.history.push(url) }}>
        <i className="material-icons">list_alt</i>
        Exibir Detalhamento
      </a>
    )
  }


  render () {
    return (
      <div className="dropdown">
        <button className="vx-actions-trigger" type="button"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i className="material-icons">more_vert</i>
        </button>
        <div className="dropdown-menu vx-gp-dropdown-menu" aria-labelledby="dropdownMenuButton">
          {this.vizualizarFechamento()}
          {this.exibirDetalhamento()}
        </div>
      </div>
    )
  }
}

export default withRouter(connect(null, { selecionarItemFechamento })(AcoesFechamentoCaixa))
